import React from 'react';
import { Typography, Box } from '@lucid/lego';
import { useStore } from '../../store/store';

const Inbox: React.FC = () => {
  const theme = useStore((state) => state.theme);

  return (
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        Inbox
      </Typography>
      <Box mt={24}>
        <Typography variant="body" size="medium" color="primary-1" theme={theme}>
          Your inbox will appear here.
        </Typography>
      </Box>
    </Box>
  );
};

export default Inbox;
